import PropTypes from 'prop-types';
import { Input } from 'reactstrap';
import Table from '../ui/Table';

const CheckboxCell = ({ original, selected = [], onCheckboxChange }) => {
  const isChecked = selected.some((item) => item.id === original.id);

  return (
    <Input
      type="checkbox"
      checked={isChecked}
      onChange={() => onCheckboxChange(original)}
    />
  );
};

CheckboxCell.propTypes = {
  original: PropTypes.object,
  selected: PropTypes.array,
  onCheckboxChange: PropTypes.func,
};

const TablaTutores = ({ data, selected, onCheckboxChange }) => {
  const columns = [
    {
      Header: 'Seleccionar',
      id: 'actions',
      CellComponent: CheckboxCell,
      cellProps: { selected, onCheckboxChange },
      sortable: false,
    },
    { Header: 'ID', accessor: 'id' },
    { Header: 'Empresa', accessor: 'empresaId' },
    { Header: 'Ciclo', accessor: 'ciclo' },
    { Header: 'Alumno', accessor: 'nombre_alumno' },
    { Header: 'Email tutor 1', accessor: 'email_tut1' },
    { Header: 'Nombre tutor 1', accessor: 'nombre_tut1' },
    { Header: 'Email tutor 2', accessor: 'email_tut2' },
    { Header: 'Nombre tutor 2', accessor: 'nombre_tut2' },
  ];

  const pageSize = data && data.length > 0 ? data.length : 10;

  return (
    <Table
      columns={columns}
      data={data}
      defaultPageSize={pageSize}
      showPaginationBottom={false}
      className="-striped -highlight mt-5 text-center"
    />
  );
};

TablaTutores.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  selected: PropTypes.array,
  onCheckboxChange: PropTypes.func,
};

export default TablaTutores;
